import React from 'react';
import Cleave from 'cleave.js/react';
import { CleaveOptions } from 'cleave.js/options';

type MaskedCustomProps = {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
  maskOptions: CleaveOptions;
  className: string;
  placeholder?: string;
  value?: string;
  id?: string;
  disabled?: boolean;
};

/**
 * A custom container component that encapsulates cleave's implementation.
 * We need to forward connections to onChange and onBlur methods
 */
const MaskedCustom = ({
  onChange,
  onBlur,
  maskOptions,
  className,
  placeholder = '',
  value = '',
  id = '',
  disabled = false,
}: MaskedCustomProps): JSX.Element => {
  return (
    <Cleave
      id={id}
      className={className}
      placeholder={placeholder}
      value={value}
      options={maskOptions}
      onBlur={onBlur}
      onChange={(event): void => onChange(event)}
      disabled={disabled}
    />
  );
};

export default MaskedCustom;
